import Experiment from '@mc/experiments-react'

import { SubscriptionProps, Props } from './SubscriptionProps'

import { PERSONA_IN_TIERS_FLAG_NAME } from '../../constants'

export const ExperimentWrapper = (props: Props) => (
  <Experiment
    name={PERSONA_IN_TIERS_FLAG_NAME}
    control={() => null}
    default={SubscriptionProps}
    {...props}
  />
)
